import { render } from "./StatsBuilderAddRowModal.vue?vue&type=template&id=676b3da2&scoped=true"
import script from "./StatsBuilderAddRowModal.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderAddRowModal.vue?vue&type=script&lang=ts"

import "./StatsBuilderAddRowModal.vue?vue&type=style&index=0&id=676b3da2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-676b3da2"

export default script